import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteLeafCollectionDetailsReportListing } from './Pages'

export const RouteLeafCollectionDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RouteLeafCollectionDetailsReportListing} />
    </Fragment>
)